import { assertSupabaseConfigured, supabase } from "../lib/supabase";

export type FeatureAvailability = Record<string, boolean>;

export const workspaceFeatureService = {
  async getAvailability(tenantId: string): Promise<FeatureAvailability> {
    assertSupabaseConfigured();

    const { data, error } = await supabase.rpc("get_feature_availability", {
      p_tenant_id: tenantId,
    });

    if (error) throw error;

    return Object.fromEntries((data ?? []).map((item) => [item.key, item.enabled]));
  },
};
